import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";

export const useHideInterventionSectionRecommendation = (): boolean => {
  const { observationId } = useInterventionSectionContext();

  // Check `observationId` instead of `observation?.id` to make sure
  // commponent stay mounted during observation fetch
  return !observationId;
};
